import 'assets/styles/compliance.scss';

import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useStore } from 'hooks';
import * as config from "../../config/constants";
import ReportGraph from "../../shared/ReportGraph/index";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import {Button} from "@material-ui/core";
import { useLocation } from 'react-router-dom';
import {makeStyles} from "@material-ui/core/styles";
import AnnouncementOutlinedIcon from "@material-ui/icons/AnnouncementOutlined";
import ShieldIcon from '../../assets/icons/shield-icon.svg';

const useStyles = makeStyles(() => ({
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start', // ✅ anchor top
    flexWrap: 'nowrap',
    gap: '1rem',
    padding: '0.5rem 1rem 0 1rem', // ✅ reduce top padding
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    minWidth: 0,
  },
  headerIcon: {
    backgroundImage: `url(${ShieldIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    width: 'clamp(1.2rem, 3vw, 2rem)',
    height: 'clamp(1.2rem, 3vw, 2rem)',
    flexShrink: 0,
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexShrink: 1,
    minWidth: 0,
    overflow: 'hidden',
  },
  headerTitle: {
    position: 'absolute',
    fontWeight: '400 !important',
    margin: '0 !important',
    marginTop: '6px !important',
    marginLeft: '50px !important',
    color: '#000 !important',
    fontSize: 'clamp(14px, 1vw, 25px) !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.5rem',
    flexShrink: 1,
    minWidth: 0,
    overflow: 'hidden',
    paddingTop: 0,
    marginTop: 0,
  },
  datePicker: {
    flexShrink: 1,
    minWidth: 0,
    maxWidth: '140px',
    margin: 0, // ✅ remove bottom spacing
    padding: 0,
    '& input': {
      fontSize: 'clamp(0.6rem, 1.2vw, 0.9rem) !important',
      padding: '4px 8px !important',
      boxSizing: 'border-box',
    },

    '& .MuiInputBase-root': {
      fontSize: 'clamp(0.6rem, 1.2vw, 0.9rem) !important',
      height: '32px',
      marginTop: '0 !important',
    },

    '& .MuiInputLabel-root': {
      fontSize: 'clamp(0.6rem, 1.2vw, 0.9rem) !important',
      transform: 'translate(14px, 12px) scale(1) !important',
      top: 0,
    },

    '& .MuiFormLabel-root.Mui-focused': {
      transform: 'translate(14px, -6px) scale(0.75) !important',
    },
  },
  searchButton: {
    fontSize: 'clamp(0.6rem, 1.2vw, 0.9rem)',
    padding: '0.25rem 0.75rem',
    minWidth: '80px',
    alignSelf: 'flex-start', // ✅ align to top
    marginTop: 0,
  },
  scrollableList: {
    maxHeight: '500px', // ⬅️ approx height for 2 items, adjust as needed
    overflowY: 'auto',
    paddingRight: '1px', // space for scrollbar
  },
  listItem: {
      padding: '1rem',
      backgroundColor: '#f8f8f8',
      borderRadius: '8px',
      marginBottom: '1rem',
      cursor: 'pointer',
      flexShrink: 0,
  },
  processHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontWeight: 600,
    marginBottom: '0.5rem',
  },
  processId: {
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  processName: {
    fontSize: '1rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1,
  },
  summary: {
    fontSize: '0.85rem',
    marginBottom: '0.75rem',
  },
  summaryLine: {
    fontWeight: 600,
    marginBottom: '0.3rem',
  },
  summaryMetrics: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },

  summaryLineItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    whiteSpace: 'nowrap',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  number: {
    fontWeight: 700,
    marginLeft: '0.3rem',
  },
  graph: {
    marginTop: '0.5rem',
  },
}));

const Report = (props) => {
  const [businessProcessesData, setBusinessProcessesData] = useState();
  const [businessProcessesNext, setBusinessProcessesNext] = useState('');
  const [businessProcessesCount, setBusinessProcessesCount] = useState(0);
  const [businessProcessesDisplayCount, setBusinessProcessesDisplayCount] = useState(0);
  const [docRegulationUnderControlCount, setDocRegulationUnderControlCount] = useState();
  const [logMonitoringData, setLogMonitoringData] = useState();
  const [businessProcessesLoading, setBusinessProcessesLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const store = useStore();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const numRecordPage = config.pageSize;
  const { customProp, embedded } = props;
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [selectedDateEnd, setSelectedDateEnd] = React.useState(new Date());
  const location = useLocation();
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };
  const handleSearch = () => {
    getDocRegulationPercentageByRange();
  };
  const getDocRegulationPercentage = async (regulation_document_id) => {
    try {
      const { data } = await store.api.getRegulationPercentage(regulation_document_id);
      return data;
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    }
  };
  const formatDate = (date) => {
    const d = new Date(date);
    let day = '' + d.getDate(),
        month = '' + (d.getMonth() + 1),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [day, month, year].join('-');
  }

  const getMonitoringLogs = async (regulation_document_id, startDateString, endDateString) => {
    try {

      const { data } = await store.api.getMonitoringLogs(regulation_document_id,startDateString, endDateString);

      return data;
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    }
  };

  const getDocRegulationPercentageByRange = async () => {
    try {
      var dict = {};
      const startDateString = formatDate(selectedDate);
      const endDateString = formatDate(selectedDateEnd);
      const promises = businessProcessesData.map(async (regulation_document, i) => {
         dict[regulation_document.id] =  await getMonitoringLogs(regulation_document.id, startDateString, endDateString);
      });
      await Promise.all(promises);
      setLogMonitoringData(dict);
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    }
  };

  const getBusinessProcesses = async () => {
    try {
      setIsLoading(true);
      const { data } = await store.api.getDocumentRegulations(customProp);
      setBusinessProcessesData(data);
      setBusinessProcessesNext(data.next);
      setBusinessProcessesCount(data.count);
      data.count > numRecordPage
        ? setBusinessProcessesDisplayCount(numRecordPage)
        : setBusinessProcessesDisplayCount(data.count);

      var monitoringData ={};
      var dict ={};
      const today = new Date();
      const threeMonthsAgo = new Date(today.setMonth(today.getMonth() - 3));
      threeMonthsAgo.setDate(1);
      setSelectedDate(threeMonthsAgo);
      const startDateString = formatDate(threeMonthsAgo);
      const endDateString = formatDate(selectedDateEnd);
      const monitoringLogs = data.map(async (regulation_document, i) => {
         monitoringData[regulation_document.id] =  await getMonitoringLogs(regulation_document.id,startDateString, endDateString);
         dict[regulation_document.id] =  await getDocRegulationPercentage(regulation_document.id);
      });
      await Promise.all(monitoringLogs);
      setLogMonitoringData(monitoringData);
      setDocRegulationUnderControlCount(dict);
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getNextBusinessProcesses = async () => {
    try {
      setBusinessProcessesLoading(true);
      const { data } = await store.api.getNextDataWithURL(businessProcessesNext);
      let addNewDomains = businessProcessesData;
      setBusinessProcessesNext(data.next);
      setBusinessProcessesData(undefined);
      const arrayLength = data.results.length;
      data.results.map((process, i) => {
        addNewDomains.push(process);
        if (arrayLength === i + 1) {
          setBusinessProcessesData(addNewDomains);
          setBusinessProcessesLoading(false);
          setBusinessProcessesDisplayCount(businessProcessesDisplayCount + arrayLength);
        }
      });
    } catch (error) {
      setBusinessProcessesLoading(false);
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setBusinessProcessesLoading(false);
    }
  };

  function LoadingMask() {
      return (
          <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }}>
              <p style={{ color: 'white' }}>Loading...</p>
          </div>
      );
  };

  useEffect(() => {
    getBusinessProcesses();
  }, [location.pathname]);

  const navigateToBusinessProcess = (processId) => {
    const path = '/micro-regulatory-list?regulation=' + processId;
    history.push(path);
  };

  return (
    <section className={'compliance-container'}  style={
          embedded
            ? { width: '100%', position: 'relative', left: '10px' }
            : undefined
        }>
       {!embedded && ( <div className="back-nav" onClick={() => history.push('/companies-dashboard')}>
        Home
      </div> )}
      <div className={classes.topBar}>
      <div className={classes.leftSection}>
        <div className={classes.headerIcon} />
        <h4 className={classes.headerTitle}>
         {customProp === 'regulation' ? 'Real-time Regulation Control Report': 'Real-time Ops Controls Report' }
        </h4>
      </div>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className={classes.rightSection}>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            id="start-date"
            value={selectedDate}
            onChange={handleDateChange}
            className={classes.datePicker}
            KeyboardButtonProps={{ 'aria-label': 'change date' }}
          />
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            id="end-date"
            value={selectedDateEnd}
            onChange={handleDateChangeEnd}
            className={classes.datePicker}
            KeyboardButtonProps={{ 'aria-label': 'change date' }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            className={classes.searchButton}
          >
            Search
          </Button>
        </div>
      </MuiPickersUtilsProvider>
      </div>
      <ul className="categories-list">
        {!embedded && (<li key="count" style={{ backgroundColor: '#f4f5f7' }}>
          <span>
            Displaying {businessProcessesDisplayCount} of {businessProcessesCount} Regulation
            Documents
          </span>
        </li>)}
        <div className={classes.scrollableList}>
        {embedded && businessProcessesData !== undefined &&  docRegulationUnderControlCount !== undefined &&
          businessProcessesData.map((process, i) => {
            const processId = process.id;
            const applicable = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].applicable: 0;
            const validation_passed = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].validation_passed: 0;
            const total = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].total: 0;
            return (
                  <li key={i} className={classes.listItem} onClick={() => navigateToBusinessProcess(processId)}>
                    {/* Header: ID + Name */}
                    <div className={classes.processHeader}>
                      <span className={classes.processId}>{processId}</span>
                      <span className={classes.processName}>
                        {process.name}
                      </span>
                    </div>

                    {/* Summary */}
                    <div className={classes.summary}>
                      <div className={classes.summaryLine}>
                        Summary:
                      </div>
                        <div className={classes.summaryMetrics}>
                          <div className={classes.summaryLineItem}>
                            <span>% Processes Validated:  {(validation_passed * 100 / applicable).toFixed(2)}%</span>

                          </div>
                          <div className={classes.summaryLineItem}>
                            <span>Applicable Compliance Processes:   {applicable}</span>
                          </div>
                          <div className={classes.summaryLineItem}>
                            <span>Total Compliance Processes: {total}</span>

                          </div>
                    </div>
                    </div>

                    {/* Graph */}
                    <div className={classes.graph}>
                      {isLoading ? (
                        <LoadingMask />
                      ) : (
                        <ReportGraph
                          data={logMonitoringData}
                          index={i}
                          selectedDate={selectedDate}
                          selectedEndDate={selectedDateEnd}
                        />
                      )}
                    </div>
                  </li>
            );
          })}
        </div>
          {!embedded && businessProcessesData !== undefined &&  docRegulationUnderControlCount !== undefined &&
          businessProcessesData.map((process, i) => {
            const processId = process.id;
            const applicable = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].applicable: 0;
            const validation_passed = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].validation_passed: 0;
            const total = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].total: 0;
            return (
              <li key={i} onClick={() => navigateToBusinessProcess(processId)}>
                <span>{processId}</span>
                <span className="title-spacing"> <span style={{fontSize:'15px'}}>{process.name}</span></span>
                <div className="summary">
                  Summary:
                  <span> % Processes Validated: <span className="number">{(validation_passed * 100/applicable).toFixed(2)}%</span></span>
                  <span className="total">Applicable Compliance Processes : <span className="number">{applicable}</span></span>
                  <span className="total-passed">Total Compliance Processes :  <span className="number">{total}</span></span>
                </div>
                <div className="graph">
                  {isLoading  ? (
                        <LoadingMask />
                      ) : (
                         <ReportGraph data={logMonitoringData} index={i} selectedDate={selectedDate} selectedEndDate={selectedDateEnd}/>
                      )}
                 </div>
              </li>
            );
          })}
        {businessProcessesCount > 10 && (
          <li className="get-next" key="next" onClick={() => getNextBusinessProcesses()}>
            <span>{businessProcessesLoading ? 'Loading...' :  'Load ' + numRecordPage.toString() + ' more'}</span>
          </li>
        )}
      </ul>
    </section>
  );
};

Report.defaultProps = {};

export default Report;
